
    import '/vercel/path0/docs/demo/pure.md?watch=parent';
    export const toc = [];
export const frontmatter = {"title":"pure-debug","toc":"menu","filename":"docs/demo/pure.md","lastUpdated":1767583902000,"nav":{"title":"Demo","path":"/demo"}};